import { makeStyles } from '@material-ui/styles';
import { MainButton, Text, IconButton, CloseFill } from '@bizzabo/design-system';
import { IAwarenessTooltipProps } from '../../types/appTools';

interface AppToolBarTooltipProps extends IAwarenessTooltipProps {
    icon?: JSX.Element;
    title?: string;
    text?: string;
}

const AppToolBarTooltip: React.FC<AppToolBarTooltipProps> = ({
    icon,
    title,
    text,
    onClose,
    onOpenApp,
}) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.btnContainer}>
                <IconButton
                    icon={CloseFill}
                    className={classes.closeBtn}
                    size="small"
                    onClick={onClose}
                />
            </div>
            {icon}
            <Text variant="t60" className={classes.title}>
                {title}
            </Text>
            <Text variant="t71" className={classes.text}>
                {text}
            </Text>
            <div className={classes.btnContainer}>
                <MainButton onClick={onOpenApp}>Try it</MainButton>
            </div>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: 215,
            padding: 9,
        },
        btnContainer: {
            display: 'flex',
            justifyContent: 'end',
        },
        closeBtn: {
            fontSize: 24,
            background: 'none',
            color: theme.customization.interactive.G30,
            '&:hover': {
                background: 'none',
            },
        },
        title: {
            color: theme.customization.interactive.G50,
        },
        text: {
            marginBottom: 10,
            color: theme.customization.interactive.G50,
        },
    }),
    {
        classNamePrefix: 'AppToolBarTooltip',
    }
);

export default AppToolBarTooltip;
